
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 35 35"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_b)"}},[_c('circle',{attrs:{"cx":"17.5","cy":"17.5","r":"17.5","fill":"#13285F"}})]),_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M9.1 25.9l15.75-15.75m0 15.75L9.1 10.15"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_b","width":"43","height":"43","x":"-4","y":"-4","color-interpolation-filters":"sRGB","filterUnits":"userSpaceOnUse"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feGaussianBlur',{attrs:{"in":"SourceGraphic","stdDeviation":"2"}}),_c('feComposite',{attrs:{"in2":"SourceAlpha","operator":"in","result":"effect1_backgroundBlur"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_backgroundBlur","result":"shape"}})])])])
          )
        }
      }
    